<template>
  <div class="absolute bottom-[23px] right-[22px] flex opacity-90 sm:hidden">
    <Button
      @click="click('left')"
      size="sm"
      variant="tertiary"
      :disabled="mobileActiveTab === 'left'"
      class="w-full rounded-r-none border-r-transparent !p-[10px] !border-gpx_black-50 !bg-black !text-gpx_gray-100 hover:!opacity-80 disabled:!border-gpx_black-50 disabled:!bg-gpx_black-50 disabled:!text-white"
    >
      <ListBulletIcon class="h-[18px]" />
    </Button>
    <Button
      @click="click('right')"
      size="sm"
      variant="tertiary"
      :disabled="mobileActiveTab === 'right'"
      class="w-full rounded-l-none border-l-transparent !p-[10px] -translate-x-px !border-gpx_black-50 !bg-black !text-gpx_gray-100 hover:!opacity-80 disabled:!border-gpx_black-50 disabled:!bg-gpx_black-50 disabled:!text-white"
    >
      <MapIcon class="h-[18px]" />
    </Button>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
  },
  methods: {
    click(tab) {
      this.$store.dispatch(`${this.type}/setMobileActiveTab`, tab);
    },
  },
  computed: {
    mobileActiveTab() {
      return this.$store.getters[`${this.type}/mobileActiveTab`];
    },
  },
};
</script>
